import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

const mapLocation = (loc) => ({
  _id: loc.id,
  name: loc.name,
  lat: loc.latitude,
  long: loc.longitude,
  status: loc.status === 'ACTIVE',
  createdAt: loc.created_at,
  updatedAt: loc.updated_at,
});

export const getLocations = createAsyncThunk('GET LOCATIONS', async (data, thunkAPI) => {
  let query = `?page=${data.page}&limit=${data.limit}&text=${data.text}`;

  const response = await axiosAdmin.get(`${URL.LOCATIONS}${query}`, thunkAPI);
  const raw = response.data?.data;

  return {
    data: {
      locations: raw?.data?.map(mapLocation) || [],
      total: raw?.total_count ?? raw?.total ?? 0,
    },
  };
});

export const addLocation = createAsyncThunk('ADD LOCATION', async (data, thunkAPI) => {
  const payload = {
    name: data.name,
    latitude: parseFloat(data.lat),
    longitude: parseFloat(data.long),
    status: data.status ? 'ACTIVE' : 'INACTIVE',
  };
  const response = await axiosAdmin.post(URL.LOCATIONS, payload, thunkAPI);
  return response.data;
});

export const updateLocation = createAsyncThunk('UPDATE LOCATION', async (data, thunkAPI) => {
  const payload = { id: data._id };

  if (data.name) payload.name = data.name;
  if (data.lat !== undefined) payload.latitude = parseFloat(data.lat);
  if (data.long !== undefined) payload.longitude = parseFloat(data.long);
  if (data.status !== undefined) {
    payload.status = data.status === true ? 'ACTIVE' : 'INACTIVE';
  }

  const response = await axiosAdmin.patch(URL.LOCATIONS, payload, thunkAPI);
  return response.data;
});

export const deleteLocation = createAsyncThunk('DELETE LOCATION', async (data, thunkAPI) => {
  const response = await axiosAdmin.delete(URL.LOCATIONS, { id: data }, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  locationsData: null,
};

export const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {},
  extraReducers: {
    [getLocations.pending]: (state) => {
      state.isLoading = true;
      state.locationsData = [];
    },
    [getLocations.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.locationsData = action.payload.data;
    },
    [getLocations.rejected]: (state, action) => {
      state.isLoading = false;
      state.locationsData = [];
      toast.error(action?.payload?.message);
    },

    [addLocation.pending]: (state) => {
      state.isLoading = true;
    },
    [addLocation.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload.message);
    },
    [addLocation.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [updateLocation.pending]: (state) => {
      state.isLoading = true;
    },
    [updateLocation.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload.message);
    },
    [updateLocation.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action?.payload?.message);
    },

    [deleteLocation.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteLocation.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload.message);
    },
    [deleteLocation.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error();
    },
  },
});

export default locationsSlice.reducer;
